export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9634.07b1f350.jpg";